export const CostIndexRanges = [
  {
    min: Number.MIN_SAFE_INTEGER,
    max: 1,
    index: 1,
  },
  {
    min: 1,
    max: 2,
    index: 2,
  },
  {
    min: 2,
    max: 3,
    index: 3,
  },
  {
    min: 3,
    max: 4,
    index: 4,
  },
  {
    min: 4,
    max: 5,
    index: 5,
  },
  {
    min: 5,
    max: 6,
    index: 6,
  },
  {
    min: 6,
    max: 7,
    index: 7,
  },
  {
    min: 7,
    max: 8,
    index: 8,
  },
  {
    min: 8,
    max: 9,
    index: 9,
  },
  {
    min: 9,
    max: Number.MAX_SAFE_INTEGER,
    index: 10,
  },
];

export const getClassName = (v) => {
  if (v === null) {
    return "N/A";
  }

  try {
    const range = CostIndexRanges.find((r) => {
      return v >= r.min && v < r.max;
    });

    return `index-${range.index}`;
  } catch (er) {
    console.log(v, er);
  }
};
